import { finalContractSuretyBondFormTypeSchema } from '../../../../enums.mjs';
import { Data as Data$1 } from '../issued/contract/issued-final-contract-surety-bond-form.types.mjs';
import { Data as Data$2 } from './contract-surety-bond-form.types.mixins.mjs';

var Data;
(function (Data) {
    let FillData;
    (function (FillData) {
        FillData.schema = Data$1.FillData.schema.partial();
    })(FillData = Data.FillData || (Data.FillData = {}));
    let Attributes;
    (function (Attributes) {
        Attributes.schema = Data$2.Attributes.baseSchema;
    })(Attributes = Data.Attributes || (Data.Attributes = {}));
    Data.schema = Data$1.schema.extend({
        fillData: FillData.schema,
        attributes: Attributes.schema,
        bondFormType: finalContractSuretyBondFormTypeSchema.nullish(),
    });
})(Data || (Data = {}));

export { Data };
